// libs
import React, { useState } from 'react';

import { cn } from '@lyearn/style';
// components
import { InputBase } from '@lyearn/ui';
// styles
import { inputStyles } from '@/modules/classrooms/modules/gradebook/components/cells/EditableInputCell/styles';
import CellBackdrop from '@/modules/corporate/modules/database/fields/components/CellBackdrop';
// hooks
import useInputEvents from '@/modules/corporate/modules/database/fields/hooks/useInputEvents';
import { rectPositionStyles } from '@/modules/corporate/modules/database/fields/number/styles';
// styles
import { editableInputStyles } from '@/modules/corporate/modules/database/fields/text/styles';
// types
import { CellProps } from '@/modules/corporate/modules/database/types';
import { TableViewActionTypes } from '@/modules/corporate/modules/database/views/TableView/hooks/useTableViewActions/actions';

const CLASSES = {
  root: 'fixed bg-bg-primary py-8 pe-10 ps-6 rounded-4',
  input: 'text-end body-short-02 text-text-paragraph p-0 -mt-4 -mx-1',
};

function NumberEditable(props: CellProps) {
  const { column, cellData, toggleIsEditing, rowData, onAction } = props;
  const [value, setValue] = useState(cellData?.value);

  const onChange = (event: React.ChangeEvent<{ value: string }>) => {
    setValue(event.target.value);
  };

  const onClickAway = () => {
    if (value !== cellData?.value) {
      onAction({
        type: TableViewActionTypes.UpdateCellValue,
        // @ts-ignore
        payload: { fieldId: column.id, documentId: rowData._id, data: { value } },
      });
    }
    toggleIsEditing();
  };

  const { onKeyDown } = useInputEvents({ onClickAway });

  return (
    <CellBackdrop onClickAway={onClickAway}>
      {(rect) => (
        <InputBase
          autoFocus
          className={cn(editableInputStyles, inputStyles, rectPositionStyles(rect))}
          classes={CLASSES}
          type="number"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
      )}
    </CellBackdrop>
  );
}

export default NumberEditable;
